module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 64
// module chunks = 0 1 2 3 4 5 6 7 10 11